import { useState, useEffect } from 'react';

/**
 * Custom hook to detect scroll direction
 * @param {number} threshold - Amount of scroll needed before direction changes
 * @returns {string} - 'up' or 'down'
 */
export function useScrollDirection(threshold = 10) {
  const [scrollDirection, setScrollDirection] = useState('up');
  const [prevScrollY, setPrevScrollY] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      // Determine scroll direction
      if (Math.abs(currentScrollY - prevScrollY) >= threshold) {
        const newScrollDirection = currentScrollY > prevScrollY ? 'down' : 'up';
        
        setScrollDirection(newScrollDirection);
        setVisible(newScrollDirection === 'up' || currentScrollY < 100);
        setPrevScrollY(currentScrollY);
      }
    };
    
    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [prevScrollY, threshold]);

  return { scrollDirection, visible };
} 